import React from "react";
import { Box, Button, Flex } from "@chakra-ui/react";
import { FormInput } from "../FormInput";
import { FormSelect } from "../FormSelect";

export const OrganizationForm = ({
  organization = {},
  organizationTypes = [],
  handleChange,
  onCreate,
  onCancel,
  isAdding,
}) => {
  return (
    <Box
      style={{
        padding: "10px 20px",
      }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onCreate(organization);
        }}
      >
        <FormInput
          name="name"
          label="Organization/School Name"
          placeholder="Organization/School name"
          value={organization.name}
          inputOnChange={handleChange}
          type="text"
          formProps={{ isRequired: true, padding: "0", margin: "0 0 10px" }}
        />
        <FormSelect
          name="organizationType"
          label="Organization Type"
          selectOnChange={handleChange}
          value={organization?.organizationType?.id}
          formProps={{ isRequired: true, padding: "0", margin: "0 0 10px" }}
          options={organizationTypes.map((org) => ({ ...org, value: org.id }))}
        />
        <FormInput
          name="street1"
          label="Street 1"
          placeholder="Street 1"
          value={organization.street1}
          inputOnChange={handleChange}
          type="text"
          formProps={{ isRequired: true, padding: "0", margin: "0 0 10px" }}
        />
        <FormInput
          name="street2"
          label="Street 2"
          placeholder="Street 2"
          value={organization.street2}
          inputOnChange={handleChange}
          type="text"
          formProps={{ padding: "0", margin: "0 0 10px" }}
        />
        <FormInput
          name="city"
          label="City"
          placeholder="City"
          value={organization.city}
          inputOnChange={handleChange}
          type="text"
          formProps={{ isRequired: true, padding: "0", margin: "0 0 10px" }}
        />
        <FormInput
          name="state"
          label="State"
          placeholder="State"
          value={organization.state}
          inputOnChange={handleChange}
          type="text"
          formProps={{ isRequired: true, padding: "0", margin: "0 0 10px" }}
        />
        {/* <FormInput
          name="zipcode"
          label="Zip Code"
          placeholder="Zip Code"
          value={organization.zipcode}
          inputOnChange={handleChange}
          type="number"
          formProps={{ isRequired: true, padding: "0", margin: "0 0 10px" }}
        />
        <FormSelect
          name="country"
          label="Country"
          selectOnChange={handleChange}
          value={organization?.country}
          formProps={{ isRequired: true, padding: "0", margin: "0 0 10px" }}
          options={[{id: "US", name: "US", value: "US"}, {id: "IN", name: "India", value: "IN"}]}
        /> */}
        <Flex
          style={{
            justifyContent: "flex-end",
            margin: "15px 0",
          }}
        >
          {!isAdding && (
            <Button
              colorScheme="red"
              style={{
                margin: "0 10px 0 0",
              }}
              variant="outline"
              onClick={onCancel}
            >
              Cancel
            </Button>
          )}
          <Button
            colorScheme="brand"
            _hover={{
              bg: "blue.500",
            }}
            type="submit"
            isLoading={isAdding}
            loadingText="Creating..."
          >
            Add
          </Button>
        </Flex>
      </form>
    </Box>
  );
};
